import { WidgetContainer, ActionButton, CircleImages } from '@chewy/chat-library-components';
import styles from './MedicineCabinetCard.module.scss';
import { ActionDef, Pet } from '@chewy/chat-library-common';
import { getPetImageUrl } from './PetCards/petImages';




interface MedicineCabinetCardData {
  accountId?: string;
  pets?: Pet[];
  actions?: ActionDef[];
}

interface MedicineCabinetCardProps {
  data: MedicineCabinetCardData | MedicineCabinetCardData[];
  isSelectable?: boolean;
}

export default function MedicineCabinetCard({ data, isSelectable = false }: MedicineCabinetCardProps) {
  // Handle both single object and array structure from widgets
  const actualData = Array.isArray(data) ? data[0] : data;

  const pets = actualData.pets ?? [];
  const actions = actualData.actions ?? [];
  const hasActions = actions.length > 0;
  const hasPets = pets.length > 0;

  return (
    <WidgetContainer
      isSelectable={isSelectable}
      hasActions={hasActions}
      data={actualData}
    >
      <div className={styles.accountContainer}>
        <div className={styles.primaryInfo}>
          <CircleImages
            images={pets.map((pet) => ({
              id: pet.id,
              src: getPetImageUrl(pet.imageUrls?.[0], pet.breedType),
              alt: pet.name || 'Pet image',
            }))}
          />

          <div className={styles.accountInfo}>
            {hasPets ? (
              <p className={styles.accountName}>
                {pets.length <= 2
                  ? pets.map(pet => pet.name).join(', ')
                  : `${pets.slice(0, 2).map(pet => pet.name).join(', ')} + ${pets.length - 2} more`
                }
              </p>
            ) : (
              <p className={styles.accountName}>No pets found</p>
            )}

          </div>
        </div>

        {hasActions && (
            actions.map((action, index) => (
              <ActionButton key={index} action={action} widgetData={actualData} />
            ))
        )}
      </div>
    </WidgetContainer>
  );
}
